import { RouteConfig } from "vue-router";

export const SANDBOX_ROUTES: RouteConfig[] = [

];
